import { APP_RELEASE_ID, APP_VERSION } from "../config/appRelease";
import { logVersionDetection } from "../shared/pepBootDebug";
import {
  getCurrentReleaseManifest,
  isReleaseNewerThan,
} from "./releaseManifest";
import {
  getTourWorthyFeatures,
  getUnseenFeatures,
} from "./featureRegistry";

export function detectReleaseUpdate(state) {
  const currentReleaseId = APP_RELEASE_ID;
  const currentVersion = APP_VERSION;
  const lastSeenReleaseId = state.lastSeenReleaseId;
  const isNewRelease = isReleaseNewerThan(currentReleaseId, lastSeenReleaseId);

  const unseenFeatures = isNewRelease
    ? getUnseenFeatures(lastSeenReleaseId, state.dismissedFeatureIds)
    : [];

  const tourWorthyFeatures = getTourWorthyFeatures(
    unseenFeatures.filter((feature) => feature.releaseId === currentReleaseId),
  );

  const manifest = getCurrentReleaseManifest(currentReleaseId);

  const detection = {
    currentReleaseId,
    currentVersion,
    lastSeenReleaseId,
    isNewRelease,
    unseenFeatures,
    tourWorthyFeatures,
    manifest,
    releaseMeta: manifest?.meta || null,
  };

  logVersionDetection(detection);

  return detection;
}

export function hasUserSeenCurrentRelease(state) {
  return !isReleaseNewerThan(APP_RELEASE_ID, state.lastSeenReleaseId);
}
